import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAdminInfo } from '../../services/auth';
import './Header.css';

function Header({ onLogout }) {
  const { t } = useTranslation();
  const adminInfo = getAdminInfo();

  return (
    <div className="admin-header">
      <h1>{t('admin.header.title')}</h1>
      <div className="admin-header-right">
        <span className="admin-name">{adminInfo?.name || adminInfo?.email || t('admin.header.fallback_admin')}</span>
        <button onClick={onLogout} className="btn btn-danger">
          {t('admin.header.logout')}
        </button>
      </div>
    </div>
  );
}

export default Header;






